import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SchoolRosterStudent } from '@k12/models';
import { MatButton } from '@angular/material/button';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-endorsed-actions',
  imports: [MatButton],
  templateUrl: './endorsed-actions.component.html',
  styleUrl: './endorsed-actions.component.scss'
})
export class EndorsedActionsComponent {
  @Input() student: SchoolRosterStudent | null = null;
  @Output() withdrawalRequested = new EventEmitter<SchoolRosterStudent>();
  @Output() costCorrectionRequested = new EventEmitter<SchoolRosterStudent>();

  protected get canStartCostCorrection(): boolean {
    return !!this.student && !this.student.hasPendingCostCorrection;
  }

  public onWithdrawal() {
    if (!this.student) return;
    this.withdrawalRequested.emit(this.student);
  }

  protected onCostCorrection() {
    if (!this.canStartCostCorrection || !this.student) return;
    this.costCorrectionRequested.emit(this.student);
  }
}
